import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import useShop from "../../../../hooks/useShop";
import useUser from "../../../../hooks/useUsers";
import { array } from "../../../../routes";
import { canAccessLaborFee } from "../../../../shared/utils/repairShopOption";
import { theme } from "../../../../theme";
import Box from "./components/Box";

interface Props {}
/**
 * @TODO ROOT 안정화 후 메뉴 통일화 시킬 것
 * @returns
 */

const Menus: React.FC<Props> = () => {
  const { pathname } = useLocation();

  const { accountRevision, getAdminInfo } = useUser();
  const { shop } = useShop();

  const [selectIdx, setIdx] = useState(setInitialIndex());

  function setInitialIndex() {
    for (let i = 0; i < array.length; i += 1) {
      if (array[i].mainLink.path === pathname) return i;
      for (let j = 0; j < array[i].subLink.length; j += 1) {
        if (pathname.includes(array[i].subLink[j].path)) return i;
      }
    }
    return -1;
  }
  /**
   * 출장매장 여부
   * @notice 임시
   */
  const isOnsite = useMemo(() => {
    return getAdminInfo()?.repairShopType === "출장교체";
  }, [accountRevision, shop]);

  const showLaborFee = useMemo(() => {
    return canAccessLaborFee(getAdminInfo());
  }, [accountRevision, shop]);

  useEffect(() => {
    setIdx(setInitialIndex());
  }, [pathname]);
  return (
    <>
      <BoxWrap>
        {array
          .map((menu, originalIndex) => ({ menu, originalIndex }))
          .filter(({ menu: { mainLink } }) => {
            if (isOnsite) return mainLink.name === "예약관리";
            if (mainLink.name === "오일 및 패드 공임표") return showLaborFee;
            return true;
          })
          .map(({ menu: { mainLink, subLink }, originalIndex }) => {
            if (mainLink.path) {
              return (
                <Link to={mainLink.path} key={originalIndex}>
                  <MainBox
                    onClick={() => setIdx(originalIndex)}
                    isNow={pathname === mainLink.path}
                  >
                    <StyledTitle>
                      <StyledIcon> {mainLink.icon}</StyledIcon>
                      {mainLink.name}
                    </StyledTitle>
                  </MainBox>
                </Link>
              );
            }
            return (
              <Box
                setIdx={() => {
                  setIdx(originalIndex);
                }}
                setClose={() => {
                  setIdx(-1);
                }}
                open={selectIdx === originalIndex}
                key={originalIndex}
                subLink={subLink}
                mainLink={mainLink}
              />
            );
          })}
      </BoxWrap>
    </>
  );
};

export default Menus;

export const BoxWrap = styled.div`
  padding: 0px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.color.gray};
`;
export const MainBox = styled.div<{ isNow: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* 인터넷익스플로러 */
  user-select: none;
  padding: 0px 16px;
  box-sizing: border-box;

  ${theme.typo.heading.b14};
  fill: ${theme.colors.gray2};
  background-color: ${({ theme }) => theme.color.gray};
  color: ${theme.colors.gray2};
  ${theme.typo.heading.b14};
  box-sizing: border-box;
  stroke: ${theme.colors.gray2};
`;
export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  ${theme.typo.heading.b14}
`;
export const StyledIcon = styled.span`
  margin-right: 16px;
  height: 24px;
`;
